import {Component, Input} from '@angular/core';
import {FormBaseComponent, ValidatorService} from '@utils-lib';
import {OrtDesSitzes} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';

const minLength = 1;
const maxLength = 50;

@Component({
  selector: 'common-ui-ort-des-sitzes',
  templateUrl: './ort-des-sitzes.component.html'
})
export class OrtDesSitzesComponent extends FormBaseComponent<OrtDesSitzes> {

  @Input()
  public stammdatenOrtDesSitzes: string;

  constructor(private readonly formBuilder: FormBuilder,
              private readonly validatorService: ValidatorService,
              protected readonly messageService: DatevMessageService) {
    super(messageService);
  }

  protected createForm(): void {
    this.form = this.formBuilder.group({
      ortDesSitzes: [this.data.ortDesSitzes, [
        this.validatorService.minLength(minLength),
        this.validatorService.maxLength(maxLength)
      ]]
    });
  }
}
